export const BasicCode = `import React from "react";
import { useForm } from "formydable";

const FormBasic = () => {
    const registerSchema = {
        fname: { label: "First Name", rules: "required|alpha|min:3" },
        lname: { label: "Last Name", rules: "required|alpha|min:3|max:20" }, 
    };

    const { formState, formUpdate } = useForm(registerSchema);

    const { fname, lname } = formState(); 
    
    return ( 
        <form> 
            <div className="n-form-field">
                <label>First Name</label>
                <input 
                    className="n-form-control"
                    name="fname" 
                    placeholder="first name..."
                    onChange={formUpdate}
                />
                {fname.isInvalid && <div className="error-feedback">{fname.message}</div>}
            </div>
            <div className="n-form-field">
                <label>Last Name</label>
                <input 
                    className="n-form-control"
                    name="lname"
                    placeholder="last name..."
                    onChange={formUpdate}
                /> 
                {lname.isInvalid && <div className="error-feedback">{lname.message}</div>} 
            </div>
        </form> 
    );
}

#render(<FormBasic />)`;

export const Controllable = `import React from "react";
import { useForm } from "formydable";

const FormControllable = () => {
    const usernameDefault = "mytabworks"
    const registerSchema = {
        username: { label: "Username", rules: "required|alpha_slug|min:5", value: usernameDefault },
        email: { label: "E-mail", rules: "required|email" }, 
    };

    const { formState, formUpdate } = useForm(registerSchema);

    const { username, email } = formState(); 
    
    return ( 
        <form> 
            <div className="n-form-field">
                <label>Username</label>
                <input 
                    className="n-form-control"
                    name="username"
                    value={username.value}
                    placeholder="username..."
                    onChange={formUpdate}
                />
                {username.isInvalid && <div className="error-feedback">{username.message}</div>}
            </div>
            <div className="n-form-field">
                <label>E-mail</label>
                <input 
                    className="n-form-control"
                    name="email"
                    value={email.value}
                    placeholder="e-mail..."
                    onChange={formUpdate}
                /> 
                {email.isInvalid && <div className="error-feedback">{email.message}</div>} 
            </div>
        </form> 
    );
}

#render(<FormControllable />)`;

export const CustomMessages = `import React from "react";
import { useForm } from "formydable";

const CustomMesssages = () => {
    const registerSchema = {
        reaction: { label: "Reactions", rules: "required|alpha_space|min:10|max:20" }
    };

    const { formState, formUpdate } = useForm(registerSchema);

    const reaction = formState("reaction"); 
    
    return ( 
        <form>   
            <div className={\`n-form-field\${reaction.isInvalid 
                ? " n-form-invalid" 
                : reaction.isValidated 
                    ? " n-form-valid" 
                    : ""}\`
                }>
                <label>what is on your mind?</label>
                <textarea 
                    className="n-form-control"
                    name="reaction"
                    value={reaction.value}
                    placeholder="try type anything..."
                    onChange={formUpdate}
                />
                {reaction.isInvalid && <div className="n-invalid-feedback">{
                    reaction.failedIn === "min" 
                    ? "That is too short" 
                    : reaction.failedIn === "max" 
                    ? "That is too long"
                    : reaction.message }
                </div>} 
                <div className="n-valid-feedback"><span role="img">✔️</span> Looks Good!</div>
            </div>
        </form> 
    );
}

#render(<CustomMesssages />)`;

export const WithSubmitCode = `import React from "react";
import { useForm } from "formydable"; 

const FormWithSubmit = () => {
    const registerSchema = { 
        gender: { label: "Gender", rules: "required" },
        biography: { label: "Biography", rules: "required|alpha_space|min:20|max:100" },
        "languages[]": { label: "Language You Like", rules: "required|min:2|max:3" }
    };
    
    const { formState, formUpdate, formSubmit } = useForm(registerSchema);

    const { gender, biography, "languages[]": languages } = formState(); 

    const formSubmitHandler = formSubmit((event) => {
        if (event.isReady()) {
            MockRequest("/mock/url-encoded/request", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: event.param()
            }) 
            .then((response) => { 
                Alert(response.json(), "success")
            })

            event.reset()
            
        } else {
            Alert("Failed! all field rules must fulfilled", "danger")
            event.locateFailed()
        }
    }); 

    const messageDisplay = (fieldstate) => fieldstate.isInvalid && <div className="error-feedback">{fieldstate.message}</div>
    
    return ( 
        <form onSubmit={formSubmitHandler}>  
            <div className="n-form-field">
                <label>Gender</label>
                <select className="n-form-control" name="gender" onChange={formUpdate}>
                    <option value="">Choose gender</option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                </select>  
                {messageDisplay(gender)}
            </div> 
            <div className="n-form-field">
                <label>Biography</label>
                <textarea className="n-form-control" name="biography" onChange={formUpdate} />
                {messageDisplay(biography)} 
            </div>
            <div className="n-form-field">
                <label className="n-form-check">
                    <input className="n-form-control" type="checkbox" name="languages[]" value="js" onClick={formUpdate} />
                    js
                </label>
                <label className="n-form-check">
                    <input className="n-form-control" type="checkbox" name="languages[]" value="c#" onClick={formUpdate} />
                    c#
                </label>
                <label className="n-form-check">
                    <input className="n-form-control" type="checkbox" name="languages[]" value="c++" onClick={formUpdate} />
                    c++
                </label>
                <label className="n-form-check">
                    <input className="n-form-control" type="checkbox" name="languages[]" value="python" onClick={formUpdate} />
                    python
                </label>
            </div>
            {messageDisplay(languages)}
            <button type="submit" className="n-btn">Submit</button>
        </form> 
    );
}

#render(<FormWithSubmit/>)`;

export const AdvanceCode = `import React from "react";
import { useForm, useFormSupplier, FormSupplier } from "formydable"; 

const FormWrapper = ({children, onSubmit}) => {
    const { formState, formUpdate, formSubmit, formRegistry } = useForm();
    
    const formSubmitHandler = formSubmit(onSubmit);  
    
    return ( 
        <FormSupplier value={{ formState, formUpdate, formRegistry }}>
            <form onSubmit={formSubmitHandler}> 
                {children}
                <button type="submit" className="n-btn">Submit</button>
            </form>
        </FormSupplier> 
    );
}

const InputWithRules = ({type = "text", name, label, rules, value = "", placeholder = "enter here...", id}) => { 

    const { formState, formUpdate, formRegistry } = useFormSupplier(); 
 
    formRegistry({ name, label, rules, value }) 
    
    const fieldstate = formState(name); 
    
    const validity = (
            fieldstate.isInvalid 
            ? "n-form-invalid" 
            : fieldstate.isValidated 
            ? "n-form-valid"
            : ""
        )

    return ( 
        <div className={\`n-form-field \${validity}\`}>
            <label htmlFor={id || name}>
                {label}
                {rules.includes("required") && (
                    <span className="label-required">*</span>
                )}
            </label>
            <input 
                className="n-form-control"
                id={id || name}
                type={type}
                name={name}
                value={type !== "file" ? fieldstate.value : undefined}
                placeholder={placeholder}
                onChange={formUpdate} 
            /> 
            <div className="n-invalid-feedback">
                {fieldstate.isInvalid && fieldstate.message}
            </div> 
            <div className="n-valid-feedback">
                <span role="img">✔️</span> Looks good!
            </div>  
        </div>
    );
}

const MockSubmit = (event) => {
    if (event.isReady()) {  
        MockRequest("/mock/json/request", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: event.json()
        }) 
        .then((response) => {
            Alert(response.json(), "success")
        }) 

        event.reset() 

    } else {
        Alert("Failed! all field rules must fulfilled", "danger")
        event.locateFailed()
    }
}

#render(
    <FormWrapper onSubmit={MockSubmit}>
        <InputWithRules name="fname" label="First Name" rules="required|alpha|min:3" />
        <InputWithRules name="lname" label="Last Name" rules="required" />
        <InputWithRules name="email" label="E-mail" rules="required|email" />
        <InputWithRules type="file" name="resume" label="Resume" rules="mimes:pdf,png|min_size:100|max_size:1000" />
    </FormWrapper>
)`;

export const AliasRegistry = `import React from "react";
import { useFormSupplier } from "formydable"; 

const InputMultiple = (props) => {

    const [fields, setFields] = React.useState([
        {...props, alias: \`unique-id-\${Math.random()}\`}
    ]); 

    return (
        <div className="n-form-field">
            <label htmlFor={props.name}>{props.label}</label>
            {fields.map((field, index) => {  
                const btnLabel = index === 0 ? "add" : "remove"
                const handleClick = () => {  
                    setFields((state) => {
                        return index === 0 
                        ? [
                            ...state,
                            {
                                ...props,
                                alias: \`unique-id-\${Math.random()}\`,
                            }
                        ] 
                        : state.filter((value) => value.alias !== field.alias)
                    }) 
                } 

                return ( 
                    <InputWithAliasRules key={field.alias} btnLabel={btnLabel} onClick={handleClick} {...field} /> 
                )   
            })} 
        </div>
    )
}

const InputWithAliasRules = ({  type = "text", name, alias, label, rules, placeholder = "enter here...", btnLabel, onClick}) => { 
    
    const { formState, formUpdate, formRegistry } = useFormSupplier(); 
 
    formRegistry({ name, label, rules, alias })
    
    const fieldstate = formState(alias);
    
    const handleFieldChange = (event) => { 
        formUpdate({ target: event.target }, alias);
    }; 
    
    const validity = (
        fieldstate.isInvalid 
        ? "n-form-invalid" 
        : fieldstate.isValidated 
        ? "n-form-valid"
        : ""
    )

    return (   
        <div className={\`n-form-field \${validity}\`}>
            <div className="n-input-group"> 
                <input 
                    className="n-form-control"
                    id={name}
                    type={type}
                    name={name}
                    data-alias={alias}
                    placeholder={placeholder}
                    onChange={handleFieldChange} 
                /> 
                <div className="n-input-group-append">
                    <button
                        className="n-btn" 
                        type="button"
                        onClick={onClick}>
                        {btnLabel}
                    </button>
                </div>  
            </div>
            <div className="n-invalid-feedback">
                {fieldstate.isInvalid && fieldstate.message}
            </div> 
            <div className="n-valid-feedback">
                <span role="img">✔️</span> Looks good!
            </div>
        </div>   
    );
}

#render(
    <FormWrapper onSubmit={MockSubmit}>
        <InputMultiple name="favorites" label="Favorites" rules="required|alpha|min:2" />
    </FormWrapper>
);`;

export const DoneTypingCode = `import React from "react";
import { useFormSupplier, DoneTypingEvent } from "formydable"; 

const InputDoneTypingWithRules = ({  type = "text", name, label, rules, placeholder = "enter here...", id}) => { 

    const { formState, formUpdate, formRegistry } = useFormSupplier(); 
 
    formRegistry({ name, label, rules }) 
    
    const fieldstate = formState(name);
    
    const handleDoneTyping = DoneTypingEvent((event) => {
        formUpdate({ target: event.target });
    }, 300); 
    
    const validity = (
        fieldstate.isInvalid 
        ? "n-form-invalid" 
        : fieldstate.isValidated 
        ? "n-form-valid"
        : ""
    )

    return ( 
        <div className={\`n-form-field \${validity}\`}>
            <label htmlFor={id || name}>
                {label}
                {rules.includes('required') && (
                    <span className='label-required'>*</span>
                )}
            </label>
            <input 
                className="n-form-control"
                id={id || name}
                type={type}
                name={name}
                placeholder={placeholder}  
                {...handleDoneTyping}
            /> 
            <div className="n-invalid-feedback">
                {fieldstate.isInvalid && fieldstate.message}
            </div> 
            <div className="n-valid-feedback">
                Looks good!
            </div>  
        </div>
    );
}

#render(
    <FormWrapper onSubmit={MockSubmit}>   
        <InputDoneTypingWithRules name="done-typing" label="With DoneTypingEvent" rules="required|alpha|min:20|max:25" />
        <InputWithRules name="normal-change-event" label="Without DoneTypingEvent" rules="required|alpha|min:20|max:25" /> 
    </FormWrapper>
)`;

export const AliasRules = `import React from "react";
import { useFormSupplier } from "formydable";

const RadioGender = () => {
    const { formState, formUpdate, formRegistry } = useFormSupplier() 
    
    const fieldstate = formState("gender")

    formRegistry({ name: "gender", label: "Gender", rules: "required", value: "1" })

    return (
        <div className="n-form-field">
            <label>Gender</label>
            <div>
                <label className="n-form-check-inline">
                    <input className="n-form-control" type="radio" name="gender" value="1" checked={fieldstate.value === "1"} onChange={formUpdate}/>
                    male
                </label>
                <label className="n-form-check-inline">
                    <input className="n-form-control" type="radio" name="gender" value="2" checked={fieldstate.value === "2"}  onChange={formUpdate}/>
                    female
                </label>
            </div>
            {fieldstate.isInvalid && <div className="error-feedback">{fieldstate.message}</div>}
        </div>
    );
} 

#render(
    <FormWrapper onSubmit={MockSubmit}>   
        <RadioGender />
        <InputWithRules name="normal-rules" label="Normal rules" rules="required_if:gender=1" />
        <InputWithRules name="aliased-rules" label="With Alias rules" rules="required_if:gender@Gender=1@male" />
    </FormWrapper>
)`;

export const CustomRulesCode = {
    basic: `import React from "react";
import { Validator } from "formydable"; 

const strong_password = {
    exe({received}) {  
        const test = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).+$/g.test(received);
        return received.length && !test;
    },
    message: "The :attribute must have 1 small letter, 1 capital letter, 1 number, and 1 special character" 
};

Validator.rulesExtend({ strong_password });

#render(
    <FormWrapper onSubmit={MockSubmit}> 
        <InputWithRules 
            type="password" 
            name="pass-strong" 
            label="Strong Password" 
            rules="required|strong_password|min:8" 
        />   
    </FormWrapper>
)`,

    intermidiate: `import React from "react";
import { Validator } from "formydable"; 

const enumerate = {
    exe({received, parameter}) {  
        const test = parameter.split(",").includes(received);
        return received.length && !test;
    },
    message: "The :attribute must only contain :enumerate" 
};  

const required_if_checkbox = {
    exe({received, parameter, parameter_value}) {  
        const checkbox = document.querySelector(\`[name="\${parameter}"]\`)
        const test = checkbox.checked === Boolean(parameter_value) 
        return test && !received.length;
    },
    message: "The :attribute is required when :required_if_checkbox is :value" 
}; 

const same_value = {
    exe({received, parameter, data}) { 
        return received.length && data[parameter] !== received;
    },
    message: "The :attribute must be the same value with :same_value"
};

Validator.rulesExtend({ enumerate, required_if_checkbox, same_value });

#render(
    <FormWrapper onSubmit={MockSubmit}>   
        <label className="n-form-check">
            <input className="n-form-control" type="checkbox" name="checky" defaultChecked={true}/> 
            checky 
        </label>
        <InputWithRules 
            name="language" 
            label="Language" 
            rules="required_if_checkbox:checky=true|enumerate:js,c#,c++,python" 
        /> 
        <InputWithRules 
            name="confirm" 
            label="Confirm" 
            rules="required_if_checkbox:checky=true|same_value:language" 
        /> 
    </FormWrapper>
)`,

    advance: `import React from "react";
import { Validator, useFormSupplier } from "formydable"; 

const password_status = {
    allowMessageEvenValid: true,
    exe(received, parameter) {  
        const isMessageType = parameter === "short"
        let rate = 0
        const qualifications = [   
            /[A-Z]/, 
            /[a-z]/, 
            /[0-9]/, 
            /[#?!@$%^&*-]/,
            /^.{8,}$/
        ]
        qualifications.forEach((regex) => {
            if(regex.test(received)) {
                rate++
            }
        })

        const very_strong = rate === 5;
        const strong = rate > 3;
        const weak = rate >= 2;
        const very_weak = rate === 1;
        
        if(very_strong) {
            this.message = isMessageType ? "very-strong" : "The :attribute is very strong"
        } else if(strong) {
            this.message = isMessageType ? "strong" : "The :attribute is strong"
        } else if(weak) {
            this.message = isMessageType ? "weak" : "The :attribute is weak"
        } else if(very_weak) {
            this.message = isMessageType ? "very-weak" : "The :attribute is very weak"
        } else {
            this.message = isMessageType ? "super-weak" : "The :attribute is must be filled"
        }
 
        return !strong;
    }
};

Validator.rulesExtend({ password_status });

const PasswordStyle = ({name, label}) => {
    const { formState, formUpdate, formRegistry } = useFormSupplier(); 
 
    formRegistry({ name, label, rules: "password_status:short" })
    
    const state = formState(name);
    
    const handleChange = (event) => {
        formUpdate({ target: event.target });
    }

    const validity = (
        state.isInvalid 
        ? "is-invalid" 
        : state.isValidated 
        ? "is-valid"
        : ""
    )

    return ( 
        <div className="n-form-field">
            <style>
                {\`.password-prog {
                    margin-top: 2px;
                    width: 0%;
                    height: 3px;
                    background-color: crimson;
                    transition: all 200ms ease-out;
                }
                .password-prog.very-strong {
                    width: 100%;
                    background-color: rgb(80, 224, 164);
                }
                .password-prog.strong {
                    width: 75%;
                    background-color: rgb(214, 236, 164);
                }
                .password-prog.weak {
                    width: 50%;
                    background-color: rgb(235, 176, 68);
                }
                .password-prog.very-weak {
                    width: 25%;
                    background-color: rgb(241, 142, 162);
                }\`}
            </style>
            <label htmlFor={name}>{label}</label>
            <input 
                id={name}
                type="password"
                name={name}
                placeholder="enter password.." 
                className={\`n-form-control \${validity}\`} 
                onChange={handleChange}
            /> 
            <div className={\`password-prog \${(state && state.isValidated  && state.message) || ""}\`}>  
            </div>  
            <small>{(state && state.isValidated && state.message.replace("-", " "))}</small>
        </div>
    )
}

#render(
    <FormWrapper onSubmit={MockSubmit}>     
        <InputWithRules 
                type="password" 
                name="pass-status" 
                label="Password Status" 
                rules="password_status" 
            />
        <PasswordStyle name="pass-styled" label="Password Status Short" />
    </FormWrapper>
)`,
};

export const RulesUpdateMessage = `import React from "react";
import { Validator } from "formydable";

Validator.rulesUpdateMessage("alpha_dash", "Oh no!! :attribute must be with dashes")
Validator.rulesUpdateMessage("same", "Oh Ow!! :attribute must be perfectly same with :same")

#render(
    <FormWrapper onSubmit={MockSubmit}>    
        <InputWithRules id="dash-id" name="dash-cases" label="Alpha Dashes" rules="required|alpha_dash" />
        <InputWithRules name="confirm" label="Confirm Match" rules="required|same:dash-id@Alpha Dashes" />
    </FormWrapper>
)`;
